module.exports = __webpack_public_path__ + "img/level_two_lock.cf478699.png";